export default "__VITE_ASSET__DOQSCafa__"